/**
 * Утилита копирования в буфер обмена
 * Использует useClipboard из @vueuse/core (паттерн из joinup)
 * После копирования показывает toast «Скопировали!»
 */
import { useClipboard } from '@vueuse/core'
// Стор обратной связи — показ toast-уведомлений
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
import { tGlobal } from '@/plugins/i18n'

/**
 * Копирует данные в буфер обмена и показывает toast
 *
 * @param data - строка или число для копирования
 */
export const copyToClipboard = async (data: string | number) => {
  // Получаем функцию copy из composable
  const { copy } = useClipboard()
  // Копируем данные в буфер
  await copy(String(data))
  // Показываем уведомление об успехе
  const feedbackStore = useFeedbackStore()
  feedbackStore.showToast({
    type: 'success',
    message: tGlobal('profile.copiedExclamation'),
  })
}
